import { render } from "./Delivery-item.vue?vue&type=template&id=203752b0"
import script from "./Delivery-item.vue?vue&type=script&lang=js"
export * from "./Delivery-item.vue?vue&type=script&lang=js"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__